exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".descriptions ul {\n  list-style: none;\n}\n.descriptions li::before {\n  content: \"\";\n  background-color: #11bb2e;\n  display: inline-block;\n  font-size: 35px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-left: -35px;\n  margin-right: 10px;\n  margin-bottom: 2px;\n}\n.descriptions li p {\n  display: inline;\n}\n.list-button i {\n  font-size: 18px;\n  margin-right: 0;\n}\n", ""]);

// exports
